import React, { useState } from 'react';
const CubicMeterCalculator = () => {
    const [length, setLength] = useState('');
    const [width, setWidth] = useState('');
    const [height, setHeight] = useState('');
    const [cubicMeter, setCubicMeter] = useState('');
    const [explanation, setExplanation] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!length || !width || !height) {
            setError('Please enter the dimensions correctly');
            setCubicMeter('');
            setExplanation('');
            return;
        }
        const lengthValue = parseFloat(length);
        const widthValue = parseFloat(width);
        const heightValue = parseFloat(height);
        if (isNaN(lengthValue) || isNaN(widthValue) || isNaN(heightValue)) {
            setError('Please enter valid dimensions for the cube');
            setCubicMeter('');
            setExplanation('');
            return;
        }
        const volume = lengthValue * widthValue * heightValue;
        setCubicMeter(volume.toFixed(2));
        setExplanation(
            `Cube Volume (Cubic Meter) = Length × Width × Height = ${lengthValue} m × ${widthValue} m × ${heightValue} m = ${volume.toFixed(2)} m³`
        );
        setError('');
    };
    return (
        <div dir="ltr">
            <div>
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label className="form-label ms-2">Length</label>
                    </b>
                    <input
                        type="number"
                        placeholder="30"
                        value={length}
                        onChange={(e) => setLength(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">m</span>
                    </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label className="form-label ms-2">Width</label>
                    </b>
                    <input
                        type="number"
                        placeholder="20"
                        value={width}
                        onChange={(e) => setWidth(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">m</span>
                    </div>
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                    <b>
                        <label htmlFor='height' className="form-label ms-2">Height</label>
                    </b>
                    <input
                        type="number"
                        placeholder="14"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="form-control"
                        style={{ width: '150px' }}
                    />
                    <div className="input-group-append">
                        <span className="input-group-text">m</span>
                    </div>
                </div>
                <br />
                <button
                    className="btn btn-success"
                    style={{ fontSize: '20px' }}
                    onClick={handleCalculate}
                >
                    Calculate Cubic Meter
                </button>
            </div>
            <br />
            <div>
                {error !== '' ? (
                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                ) : (
                    <>
                        {cubicMeter !== '' && (
                            <>
                                <p className='p-3 mb-2 bg-success text-white'>
                                    Cube Volume (Cubic Meter): {cubicMeter} m³
                                </p>
                                {explanation !== '' && (
                                    <p className='p-3 mb-2 bg-info text-black'>
                                        Solution Steps: <br />{explanation}
                                    </p>
                                )}
                            </>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};
export default CubicMeterCalculator;
